import { render, staticRenderFns } from "./IRPF.vue?vue&type=template&id=379bff51&"
import script from "./IRPF.vue?vue&type=script&lang=ts&"
export * from "./IRPF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports